<div class="modify-book-widget-mobile">
  @if (bookWidgetFields() && bookWidgetAem()) {
    <div class="flex flex-col gap-24 pb-[150px]">
      <div class="flex flex-col gap-8">
        <idp-one-way-route-picker-mach-core
          class="min-h-[74px] h-max"
          [routePickerContent]="{
            origin: {
              title: bookWidgetAem().airportsField.from,
              subtitle: bookWidgetAem().airportsField.yourOrigin
            },
            destination: {
              title: bookWidgetAem().airportsField.to,
              subtitle: bookWidgetAem().airportsField.yourDestination
            },
            ariaLabels: {
              origin:
                bookWidgetAem().airportsField.originAriaLabel +
                (bookWidgetFields().airportsField.airports[0].fromAirportcode
                  .length
                  ? ' ' +
                    bookWidgetFields().airportsField.airports[0]
                      .fromAirportcode +
                    ', ' +
                    bookWidgetFields().airportsField.airports[0].fromCity
                  : ''),
              swapArrow: bookWidgetAem().airportsField.swapAriaLabel,
              destination:
                bookWidgetAem().airportsField.destinationAriaLabel +
                (bookWidgetFields().airportsField.airports[0].toAirportcode
                  .length
                  ? ' ' +
                    bookWidgetFields().airportsField.airports[0].toAirportcode +
                    ', ' +
                    bookWidgetFields().airportsField.airports[0].toCity
                  : '')
            }
          }"
          [routePickerCities]="{
            destinationCode:
              bookWidgetFields().airportsField.airports[0].toAirportcode,
            destinationName:
              bookWidgetFields().airportsField.airports[0].toCity,
            destinationRegion: '',
            originCode:
              bookWidgetFields().airportsField.airports[0].fromAirportcode,
            originName: bookWidgetFields().airportsField.airports[0].fromCity,
            originRegion: ''
          }"
          [routePickerError]="
            bookWidgetFields().airportsField.fieldErrorInfo?.routePickerField
          "
          [recentSearchList]="recentSearchList()"
          [savedSearchList]="savedSearchList()"
          [searchModalTabs]="searchModalTabs()"
          [isFullscreen]="isFullscreen()"
          [predictiveSearchData]="predictiveSearchData()"
          (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
          (swapClicked)="swapClicked.emit(0)"
          (searchModalEvent)="searchModalEvent.emit($event)"
        ></idp-one-way-route-picker-mach-core>
        <idp-select-mach-core
          class="h-[64px]"
          [isTitleHidden]="true"
          [title]="bookWidgetAem().tripTypesField.tripTypeAriaLabel"
          [disabled]="bookWidgetFields().tripTypesField.disable"
          [dropdownOptions]="bookWidgetFields().tripTypesField.dropdownOptions"
          (selectionChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.tripType
            )
          "
        ></idp-select-mach-core>
        <idp-date-picker-mach-core
          class="min-h-[64px] h-max"
          [selectedTripType]="
            bookWidgetFields().tripTypesField.selectedTripType
          "
          [selectedRange]="bookWidgetFields().datesField.dates[0]"
          [bookWidgetAem]="bookWidgetAem()"
          [datepickerConfig]="datepickerConfig()"
          [fieldErrorInfo]="bookWidgetFields().datesField.fieldErrorInfo?.[0]"
          (selectedDateRange)="
            onDateSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.datesChange,
              0
            )
          "
        ></idp-date-picker-mach-core>
        <idp-select-mach-core
          class="h-[64px]"
          icon="/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg"
          [isTitleHidden]="true"
          [title]="bookWidgetAem().passengerField.passengerAriaLabel"
          [hideDropdownListIcon]="true"
          [disabled]="bookWidgetFields().passengerField.disable"
          [dropdownOptions]="bookWidgetFields().passengerField.dropdownOptions"
          (selectionChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.passenger
            )
          "
        ></idp-select-mach-core>
      </div>
      <div class="flex flex-col gap-16">
        @if (!bookWidgetFields().shopMilesField.hide) {
          <div class="flex flex-row items-center justify-between">
            <label
              for="shopMiles"
              class="mb-0 text-label-md-medium text-static"
              [ngClass]="{
                '!text-disabled': bookWidgetFields().shopMilesField.disable
              }"
            >
              {{ bookWidgetAem().shopMilesField.shopWithMiles }}
            </label>
            <input
              #shopMilesCheckboxElement
              type="checkbox"
              id="shopMiles"
              class="toggle"
              [disabled]="bookWidgetFields().shopMilesField.disable"
              [checked]="bookWidgetFields().shopMilesField.checked"
              (change)="
                onToggleChange($event, bookWidgetFieldUpdateTypes.shopMiles);
                analyticsEvent.emit({ el: shopMilesCheckboxElement })
              "
            />
          </div>
        }
        @if (!bookWidgetFields().flexDatesField.hide) {
          <div class="flex flex-row items-center justify-between">
            <label
              for="flexDates"
              class="mb-0 text-label-md-medium text-static"
              [ngClass]="{
                '!text-disabled': bookWidgetFields().flexDatesField.disable
              }"
            >
              {{ bookWidgetAem().flexDatesField.flexDates }}
            </label>
            <input
              #flexDatesCheckboxElement
              type="checkbox"
              id="flexDates"
              class="toggle"
              [disabled]="bookWidgetFields().flexDatesField.disable"
              [checked]="bookWidgetFields().flexDatesField.checked"
              (change)="
                onToggleChange($event, bookWidgetFieldUpdateTypes.flexDates);
                analyticsEvent.emit({ el: flexDatesCheckboxElement })
              "
            />
          </div>
        }
        @if (!bookWidgetFields().basicFaresField.hide) {
          <div class="flex flex-row items-center justify-between">
            <label
              for="basicFaresField"
              class="mb-0 text-label-md-medium text-static"
              [ngClass]="{
                '!text-disabled': bookWidgetFields().basicFaresField.disable
              }"
            >
              {{ bookWidgetAem().includeBasicField.includeBasic }}
            </label>
            <input
              #basicFaresCheckboxElement
              type="checkbox"
              id="basicFaresField"
              class="toggle"
              [disabled]="bookWidgetFields().basicFaresField.disable"
              [checked]="bookWidgetFields().basicFaresField.checked"
              (change)="
                onToggleChange($event, bookWidgetFieldUpdateTypes.basicFares);
                analyticsEvent.emit({ el: basicFaresCheckboxElement })
              "
            />
          </div>
        }
        @if (!bookWidgetFields().refundableFareField.hide) {
          <div class="flex flex-row items-center justify-between">
            <div class="flex gap-[5px]">
              <label
                for="refundableFares"
                class="mb-0 text-label-md-medium text-static"
                [ngClass]="{
                  '!text-disabled':
                    bookWidgetFields().refundableFareField.disable
                }"
              >
                {{ bookWidgetAem().refundableFareField.refundableOnly }}
              </label>
              <img
                class="grayscale-effect"
                src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
                [attr.aria-label]="
                  bookWidgetAem().refundableFareField.refundableOnly +
                  ' ' +
                  bookWidgetAem().helpIconAriaLabel
                "
                role="button"
                tabindex="0"
                (click)="
                  infoIconClickHandler(
                    bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
                  )
                "
                (keydown.enter)="
                  infoIconClickHandler(
                    bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
                  )
                "
              />
            </div>
            <input
              #refundableFaresCheckboxElement
              type="checkbox"
              id="refundableFares"
              class="toggle"
              [disabled]="bookWidgetFields().refundableFareField.disable"
              [checked]="bookWidgetFields().refundableFareField.checked"
              (change)="
                onToggleChange(
                  $event,
                  bookWidgetFieldUpdateTypes.refundableFare
                );
                analyticsEvent.emit({ el: refundableFaresCheckboxElement })
              "
            />
          </div>
        }
      </div>
      <idp-options-expander-mach-core
        class="advance-options-toggle"
        [content]="bookWidgetAem().advancedSearchBtn"
        [isExpanded]="isAdvancedSearchExpanded()"
        (expandedEmit)="toggleAdvSearchExpandedEvent.emit()"
        (analyticsEvent)="analyticsEvent.emit({ el: $event })"
      ></idp-options-expander-mach-core>
      @if (isAdvancedSearchExpanded()) {
        <div class="flex flex-col gap-16">
          @if (!bookWidgetFields().flexAirportsField.hide) {
            <div class="flex flex-row items-center justify-between">
              <label
                for="flexAirports"
                class="mb-0 text-label-md-medium text-static"
                [ngClass]="{
                  '!text-disabled': bookWidgetFields().flexAirportsField.disable
                }"
              >
                {{ bookWidgetAem().flexAirportsField.flexAirports }}
              </label>
              <input
                #flexAirportsCheckboxElement
                type="checkbox"
                id="flexAirports"
                class="toggle"
                [disabled]="bookWidgetFields().flexAirportsField.disable"
                [checked]="bookWidgetFields().flexAirportsField.checked"
                (change)="
                  onToggleChange(
                    $event,
                    bookWidgetFieldUpdateTypes.flexAirport
                  );
                  analyticsEvent.emit({ el: flexAirportsCheckboxElement })
                "
              />
            </div>
          }
          @if (!bookWidgetFields().bestFareOptionsField.hide) {
            <idp-best-fare-options-mach-core
              [title]="bookWidgetAem().bestFareOptionsField.bestFare"
              [disabled]="bookWidgetFields().bestFareOptionsField.disable"
              [infoModalContent]="
                bookWidgetAem().bestFareOptionsField.infoModal
              "
              [dropdownOptions]="
                bookWidgetFields().bestFareOptionsField.dropdownOptions
              "
              [infoTooltipOptions]="{
                positions: 'top-right',
                color: 'high-contrast',
                triggerEvent: 'hover'
              }"
              (bestFareOptionsChange)="
                onDropdownSelectionChange(
                  $event,
                  bookWidgetFieldUpdateTypes.bestFareOptions
                )
              "
            ></idp-best-fare-options-mach-core>
          }
          @if (!bookWidgetFields().meetingEventCodeField.hide) {
            <idp-meeting-code-mach-core
              [placeholder]="bookWidgetAem().meetingEventCodeField.placeholder"
              [title]="bookWidgetAem().meetingEventCodeField.meetingEventCode"
              [value]="
                bookWidgetFields().meetingEventCodeField.meetingEventCodeValue
              "
              [disabled]="bookWidgetFields().meetingEventCodeField.disable"
              [infoModalContent]="
                bookWidgetAem().meetingEventCodeField.infoModal
              "
              [errorMessage]="
                bookWidgetFields().meetingEventCodeField.fieldErrorInfo
                  ?.errorMessage
              "
              [disclaimerMessage]="
                bookWidgetFields().meetingEventCodeField.disclaimerMessage
              "
              [tooltipOptions]="{
                positions: 'top-right',
                color: 'high-contrast',
                triggerEvent: 'hover'
              }"
              (valueChange)="
                onInputFieldChange(
                  $event,
                  bookWidgetFieldUpdateTypes.meetingEventCode
                )
              "
            ></idp-meeting-code-mach-core>
          }
          @if (!bookWidgetFields().edocsLink.hide) {
            <a
              #edocsLinkElement
              [href]="
                bookWidgetFields().edocsLink.disable
                  ? ''
                  : bookWidgetFields().edocsLink.src
              "
              [ngClass]="
                bookWidgetFields().edocsLink.disable
                  ? '!text-disabled pointer-events-none'
                  : ''
              "
              class="link link-sm"
              (click)="analyticsEvent.emit({ el: edocsLinkElement })"
            >
              {{ bookWidgetAem().edocsLink }}
            </a>
          }
        </div>
      }
      <div
        class="cta-btn-container fixed bottom-0 left-0 right-0 py-[24px] border-t border-[#AAADBD] bg-surface-02 flex justify-center items-center"
      >
        <button
          #findFlightButton
          id="findFilghtsCta"
          class="button button-primary button-md w-screen max-w-[343px] tablet:max-w-[520px]"
          role="button"
          tabindex="0"
          [attr.aria-label]="bookWidgetAem().searchBtn"
          data-acdl-name="flights:find flights"
          data-acdl-action="flight search initiation:flights search"
          data-acdl-page-section="header:book:flights"
          (click)="onFindFlightClick(findFlightButton)"
          (keydown.enter)="onFindFlightClick(findFlightButton)"
        >
          {{ bookWidgetAem().searchBtn }}
        </button>
      </div>
    </div>
  }
</div>
